// extracted by mini-css-extract-plugin
export default {"headerMain":"MainHeader_headerMain__kCmIe","headerOpening":"MainHeader_headerOpening__EIlyl","vrImg":"MainHeader_vrImg__rbunL"};